<template>
  <v-container>
    <v-layout row>
      <v-card class="scrollable" ma-0 pa-0>
        <v-card-title>
          <div class="headline truncate">
            <h4>{{$t('feeds.feed_info_title')}}</h4>
          </div>
        </v-card-title>
        <v-card-text class="pt-1">
          <v-layout row wrap>
            <v-flex style="width:50%">
              <span class="body-2">{{scheduledAt}}</span>
            </v-flex>
            <v-flex style="width:50%">
              <span class="body-2 pl-2">{{offsetDays}}</span>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="body-2 caption truncate ">
              <p>{{$t('feeds.feed_info_scheduled')}}</p>
            </v-flex>
            <v-flex class="body-2 ml-4 caption truncate align-content-start">
              <p>{{$t('feeds.feed_info_offset_days')}}</p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="caption truncate ">
              <v-icon class="mx-auto" v-if="requiredEngagement" color="black">mdi-flag</v-icon>
              <p class="body-2 mb-1" v-else>-</p>
              <p>{{$t('feeds.feed_info_required_engagement')}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'feed-request-breakdown-info-card',
    computed: {
      ...mapState({
        offsetDays: state => state.feeds.offsetDays,
        scheduledAt: state => state.feeds.scheduledAt,
        requiredEngagement: state => state.feeds.requiredEngagement
      })
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;

  }

  .right-text {
    text-align: right;
  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoCard.vue